import { render } from "./Licitacion.vue?vue&type=template&id=a395c4c2&scoped=true"
import script from "./Licitacion.vue?vue&type=script&lang=js"
export * from "./Licitacion.vue?vue&type=script&lang=js"

import "./Licitacion.vue?vue&type=style&index=0&id=a395c4c2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a395c4c2"]])

export default __exports__